import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoEn: CultureInfo = {
  name: 'en',
  displayName: 'English',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en',
  parent: null
};
